(function () {
  'use strict'

  require('dynamic-bind-html')
  require('./scss/app-embed.scss')

  var MODULE_NAME = 'thismoment.card.component.appMvaEmbed'
  var templateUrl = require('./tpl/app-mva-embed.html')

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml'
    ])
    .component('thismomentAppMvaEmbed', {
      bindings: {
        item: '<'
      },
      templateUrl: templateUrl,
      controller: appMvaEmbedController
    })

  appMvaEmbedController.$inject = ['SdkConfig', '$window', '$sce', 'ExpandedContent']
  function appMvaEmbedController (SdkConfig, $window, $sce, ExpandedContent) {
    var vm = this

    vm.isMobile = SdkConfig.get('is_mobile')
    vm.$onInit = mvaInit
    vm.embedCode = embedCode

    if (typeof ($window.TM_GLOW) !== 'undefined') {
      vm.cartEnabled = $window.TM_GLOW.GLOW_CART_ENABLED && $window.TM_GLOW.MODULES.MEDIAWALL.CART_ENABLED
    }

    function mvaInit () {
      vm.expand = imageExpand

      function imageExpand () {
        ExpandedContent.open(vm.item)
      }
    }

    function embedCode (embed) {
      return $sce.trustAsHtml(embed.embed_code)
    };
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/app-mva-embed.js